import { render, staticRenderFns } from "./SignInH5.vue?vue&type=template&id=b4e8f568&scoped=true&"
import script from "./SignInH5.vue?vue&type=script&lang=js&"
export * from "./SignInH5.vue?vue&type=script&lang=js&"
import style0 from "./SignInH5.vue?vue&type=style&index=0&id=b4e8f568&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e8f568",
  null
  
)

export default component.exports